export default __webpack_public_path__ + "static/structure-image-9928037a366b096138c1e1ae24797042.png";